import Constants from "../constants/ItemSearch";

let searchParamsCache = {};
let searchParamsCached = false;

export function getUrlParams(urlParams) {
  if (urlParams) {
    // FIX: plenty issue with '-encoding
    urlParams = urlParams.replace("%26%2339%3B", "%27");
    urlParams = urlParams.replace("%26%23039%3B", "%27");
    // END FIX
    let tokens;
    const params = {};
    const regex = /[?&]?([^=]+)=([^&]*)/g;

    urlParams = urlParams.split("+").join(" ");

    // eslint-disable-next-line
    while (tokens = regex.exec(urlParams)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
  }

  return {};
}

function reindexFacet(attributes, facetId) {
  const newValues = {};
  let i = 0;
  for (const value of Object.values(attributes[facetId])) {
    newValues[i] = value;
    i++;
  }
  attributes[facetId] = newValues;
}

export default {
  methods: {
    /*
     * Plentymarkets standart method for parsing params from string into object
     *
     * @param {string} urlParams
     * @returns {Object}
     */
    getUrlParams,

    /*
     * Findologic method for parsing url params into a parameter map from current url
     * Taken from direct integration flUtils class
     *
     * @returns {{}} The parameter map
     */
    getSearchParams() {
      if (searchParamsCached) {
        return searchParamsCache;
      }

      let queryString = typeof document !== "undefined" ? document.location.href.split("?")[1] : App.modeherzPluginConfig.currentUrl.split("?")[1];


      const requestParameters = {};

      /*
       * Remove any leading ? as it is not part of the query string but will be passed due to the way we use
       * parseQueryString
       */
      if (typeof queryString !== "undefined") {
        queryString = queryString.replace(/^\?/, "");
        queryString = queryString.split("#")[0];
      } else {
        queryString = "";
      }
      // FIX: plenty issue with '-encoding
      queryString = queryString.replace("%26%2339%3B", "%27");
      queryString = queryString.replace("%26%23039%3B", "%27");
      // END FIX
      const strArr = String(queryString)
        .replace(/^&/, "")
        .replace(/&$/, "")
        .split("&");
      const sal = strArr.length;

      let i;

      let j;

      let ct;

      let p;

      let lastObj;

      let obj;

      let undef;

      let chr;

      let tmp;

      let key;

      let value;

      let postLeftBracketPos;

      let keys;

      let keysLen;
      const fixStr = function(queryString) {
        return decodeURIComponent(queryString.replace(/\+/g, "%20"));
      };

      for (i = 0; i < sal; i++) {
        tmp = strArr[i].split("=");
        key = fixStr(tmp[0]);
        value = (tmp.length < 2) ? "" : fixStr(tmp[1]).replace(/\+/g, " ");

        while (key.charAt(0) === " ") {
          key = key.slice(1);
        }
        if (key.indexOf("\x00") > -1) {
          key = key.slice(0, key.indexOf("\x00"));
        }
        if (key && key.charAt(0) !== "[") {
          keys = [];
          postLeftBracketPos = 0;
          for (j = 0; j < key.length; j++) {
            if (key.charAt(j) === "[" && !postLeftBracketPos) {
              postLeftBracketPos = j + 1;
            } else if (key.charAt(j) === "]") {
              if (postLeftBracketPos) {
                if (!keys.length) {
                  keys.push(key.slice(0, postLeftBracketPos - 1));
                }
                keys.push(key.substr(postLeftBracketPos, j - postLeftBracketPos));
                postLeftBracketPos = 0;
                if (key.charAt(j + 1) !== "[") {
                  break;
                }
              }
            }
          }
          if (!keys.length) {
            keys = [key];
          }
          for (j = 0; j < keys[0].length; j++) {
            chr = keys[0].charAt(j);
            if (chr === " " || chr === "." || chr === "[") {
              keys[0] = keys[0].substr(0, j) + "_" + keys[0].substr(j + 1);
            }
            if (chr === "[") {
              break;
            }
          }

          obj = requestParameters;
          for (j = 0, keysLen = keys.length; j < keysLen; j++) {
            key = keys[j].replace(/^['"]/, "")
                         .replace(/['"]$/, "");
            lastObj = obj;
            if ((key !== "" && key !== " ") || j === 0) {
              if (obj[key] === undef) {
                obj[key] = {};
              }
              obj = obj[key];
            } else {
              // To insert new dimension
              ct = -1;
              for (p in obj) {
                if (obj.p) {
                  if (+p > ct && p.match(/^\d+$/g)) {
                    ct = +p;
                  }
                }
              }
              key = ct + 1;
            }
          }
          lastObj[key] = value;
        }
      }

      if (requestParameters[Constants.PARAMETER_ATTRIBUTES] === "") {
        delete requestParameters[Constants.PARAMETER_ATTRIBUTES];
      }
      delete requestParameters[Constants.PARAMETER_CATEGORY];
      delete requestParameters[Constants.PARAMETER_CACHE_BLOCK];
      delete requestParameters[Constants.PARAMETER_CACHE_BLOCK_ID];

      searchParamsCache = requestParameters;
      searchParamsCached = true;
      return requestParameters;
    },

    updateAllSelectedFilters(facets) {
      console.log("update it");
      this.$store.commit("setIsItemListLoading", true);

      const params = this.getSearchParams();

      if (!(Constants.PARAMETER_ATTRIBUTES in params)) {
        params[Constants.PARAMETER_ATTRIBUTES] = {};
      }

      const gaEvents = [];

      const attributes = params[Constants.PARAMETER_ATTRIBUTES];

      for (const facet of facets) {
        // FIX: plenty issue with '-encoding
        // const { facetId, facetValue } = facet
        let { facetId, facetValue } = facet;

        if (typeof facetValue === "string") {
          facetValue = facetValue.replace("&#039;", "'");
          facetValue = facetValue.replace("&#39;", "'");
        }
        // END FIX

        if (facetId === "price" || this.facet.findologicFilterType === "range-slider") {
          attributes[facetId] = {
            min: facetValue.min,
            max: facetValue.max
          };
          gaEvents.push({ action: facetId, label: facetValue.min + "|" + facetValue.max });
        } else if (this.facet.select === "single") {
          if (attributes[facetId] && Object.values(attributes[facetId]).includes(facetValue)) {
            if (this.facet.id === "cat" && facetValue.includes("_")) {
              // Subcategory deselection
              attributes[facetId] = [facetValue.split("_")[0]];
            } else {
              const index = Object.values(attributes[facetId]).indexOf(facetValue);

              delete attributes[facetId][index];
              reindexFacet(attributes, facetId);
            }
          } else {
            attributes[facetId] = [facetValue];
            gaEvents.push({ action: facetId, label: facetValue });
          }
        } else {
          if (!(facetId in attributes)) {
            attributes[facetId] = { 0: facetValue };
            gaEvents.push({ action: facetId, label: facetValue });
          } else {
            const valueId = this.getKeyByValue(attributes[facetId], facetValue);

            if (valueId === -1) {
              const index = Object.keys(attributes[facetId]).length;

              attributes[facetId][index] = facetValue;
              gaEvents.push({ action: facetId, label: facetValue });
            } else {
              delete attributes[facetId][valueId];
              reindexFacet(attributes, facetId);
            }
          }
        }
      }

      if (window.gtag) {
        const isSearch = !!params[Constants.PARAMETER_QUERY];
        for (const event of gaEvents) {
          window.gtag("event", "product_filter", {
            "type": (isSearch ? "search" : "navigation"),
            "value": event.label,
            "name": event.action
            // 'value': <value>
          });
        }
      }

      params[Constants.PARAMETER_ATTRIBUTES] = this.reorderKeys(attributes);
      delete params[Constants.PARAMETER_PAGE];
      delete params[Constants.PARAMETER_FACET];

      document.location.search = "?" + $.param(params);
    },
    /*
     * Update url with selected filters
     *
     * @param {string} facetId
     * @param {string|array} facetValue
     */
    updateSelectedFilters(facetId, facetValue) {
      this.updateAllSelectedFilters([{ facetId, facetValue }]);
    },

    /*
     * Check if value is selected
     *
     * @param {string} facetId
     * @param {string} facetValue
     * @returns {boolean}
     */
    isValueSelected(facetId, facetValue) {
      const params = this.getSearchParams();

      if (!(Constants.PARAMETER_ATTRIBUTES in params)) {
        return false;
      }

      const attributes = params[Constants.PARAMETER_ATTRIBUTES];

      if (!(facetId in attributes)) {
        return false;
      } else if (facetId !== "cat" && this.facet.select === "single" && attributes[facetId] === facetValue) {
        return true;
      } else if (facetId === "cat") {
        return this.getKeyBySuffix(attributes[facetId], facetValue) !== -1;
      } else if (this.getKeyByValue(attributes[facetId], facetValue) !== -1) {
        return true;
      } else {
        return false;
      }
    },

    /*
     * Get the list of selected filters from url
     *
     * @returns {Object}
     */
    getSelectedFilters() {
      const selectedFilters = [];
      const params = this.getSearchParams();

      if (!(Constants.PARAMETER_ATTRIBUTES in params)) {
        return selectedFilters;
      }
      const identCheck = new Set();
      const attributes = params[Constants.PARAMETER_ATTRIBUTES];

      for (const filter in attributes) {
        if (filter === "wizard") {
          continue;
        }

        if (filter === "price" || this.isRangeSliderFilter(attributes[filter])) {
          const facetInfo = this.getFacetIdInfoMap();

          const unit = (facetInfo[filter] && facetInfo[filter].unit) ? " " + facetInfo[filter].unit : "";

          selectedFilters.push({
            id: filter,
            name: attributes[filter].min + unit + " - " + attributes[filter].max + unit
          });

          continue;
        }

        if (typeof attributes[filter] === "object") {
          const values = attributes[filter];

          for (const value in values) {
            const name = values[value].replace(/_/g, " > ");

            // plenty bug: query params string returns multiple identical params
            const identifier = filter + "###" + name;

            if (identCheck.has(identifier)) {
              continue;
            }
            identCheck.add(identifier);

            selectedFilters.push({
              id: filter,
              name
            });
          }
          continue;
        }

        selectedFilters.push({
          id: filter,
          name: attributes[filter]
        });
      }

      return selectedFilters;
    },

    /**
     * @param attributeValue
     * @returns {boolean}
     */
    isRangeSliderFilter(attributeValue) {
      return (typeof attributeValue.min !== "undefined" && typeof attributeValue.max !== "undefined");
    },

    /*
     * Remove selected filter from url
     *
     * @param {string} facetId
     * @param {string} facetValue
     */
    removeSelectedFilter(facetId, facetValue) {
      facetValue = facetValue.replace(" > ", "_");
      const params = this.getSearchParams();
      const attributes = params[Constants.PARAMETER_ATTRIBUTES];

      if (typeof attributes[facetId] !== "object" ||
        facetId === "price" ||
        this.isRangeSliderFilter(attributes[facetId])
      ) {
        delete attributes[facetId];
      } else {
        const values = attributes[facetId];

        for (const value in values) {
          if (values[value] === facetValue) {
            delete attributes[facetId][value];
            reindexFacet(attributes, facetId);
            break;
          }
        }
      }

      params[Constants.PARAMETER_ATTRIBUTES] = this.reorderKeys(attributes);
      delete params[Constants.PARAMETER_PAGE];
      delete params[Constants.PARAMETER_FACET];

      // opt: avoid empty ? string which will break caching
      const paramsString =  $.param(params);

      if (paramsString) {
        document.location.search = "?" + paramsString;
      } else {
        document.location = document.location.href.split("?")[0];
      }
    },

    /*
     * Get selected filter value from url
     *
     * @param {string} facetId
     * @returns {Object|null}
     */
    getSelectedFilterValue(facetId) {
      const params = this.getSearchParams();

      if (!(Constants.PARAMETER_ATTRIBUTES in params)) {
        return null;
      }

      const attributes = params[Constants.PARAMETER_ATTRIBUTES];

      if (!(facetId in attributes)) {
        return null;
      }

      return attributes[facetId];
    },

    /*
     * Get simple url parameter value
     *
     * @param {string} key
     * @returns {string|null}
     */
    getUrlParamValue(key) {
      const params = this.getSearchParams();

      if (!(key in params)) {
        return null;
      }

      return params[key];
    },

    /*
     * Get simple url parameter value
     *
     * @param {string} key
     * @param {string|array} value
     */
    setUrlParamValue(key, value) {
      const params = this.getSearchParams();

      params[key] = value;

      document.location.search = "?" + $.param(params);
    },

    /**
     * Set multiple url parameter values
     *
     * @param {array} keyValueArray
     */
    setUrlParamValues(keyValueArray) {
      const params = this.getSearchParams();

      keyValueArray.forEach(function(keyValueObject) {
        params[keyValueObject.key] = keyValueObject.value;
      });

      document.location.search = "?" + $.param(params);
    },

    /*
     * Get key from object by value
     *
     * @param {Object} object
     * @param {string} value
     * @returns {string|number}
     */
    getKeyByValue(object, value) {
      for (const prop in object) {
        if (object[prop]) {
          if (object[prop] === value) {
            return prop;
          }
        }
      }

      return -1;
    },

    /*
     * Get key from object by value suffix
     *
     * @param {Object} object
     * @param {string} value
     * @returns {string|number}
     */
    getKeyBySuffix(object, value) {
      for (const prop in object) {
        if (object[prop]) {
          if (object[prop].endsWith(value)) {
            return prop;
          }
        }
      }

      return -1;
    },

    /**
     *  Remove all `attrib` url params and reload the page
     */
    removeAllAttribsAndRefresh() {
      const params = this.getSearchParams();

      delete params[Constants.PARAMETER_PAGE];
      delete params[Constants.PARAMETER_ATTRIBUTES];
      delete params[Constants.PARAMETER_FACET];

      // opt: avoid empty ? string which will break caching
      const paramsString = $.param(params);

      if (paramsString) {
        document.location.search = "?" + paramsString;
      } else {
        document.location = window.location.href.split("?")[0];
      }
    },

    getFacetIdInfoMap() {
      const map = {};

      this.$store.state.itemList.facets.forEach(facet => {
        map[facet.id] = facet;
      });

      return map;
    },

    reorderKeys(obj) {
      if( typeof obj !== "object" || obj === null) {
        return obj;
      }
      const orderedKeys = Object.keys(obj).sort();
      return orderedKeys.reduce((acc, key) => {
        acc[key] = obj[key];
        return acc;
      }, {});
    }
  }
};
